import debounce from "lodash/debounce"
import { openAccordionItem } from "../helpers"
class Accordion {
  constructor() {
    this.items = document.querySelectorAll(".accordion-item")
    this.bindEvents()
    this.setAccordionTables()
    this.openAccordionByDefault()
  }

  bindEvents() {
    this.items.forEach(i => {
      const button = i.querySelector("button")

      if (button) {
        button.addEventListener(
          "click",
          debounce(ev => {
            this.toggleItem(ev)
          }, 300)
        )
      }
    })
  }

  // adds a special class to container with tables inside accordions
  setAccordionTables() {
    let accordionContent = document.querySelectorAll(".accordion-item__content")

    accordionContent.forEach(content => {
      if (content.querySelector("table")) {
        content.classList.add("accordion-table-container")
      }
    })
  }

  openAccordionByDefault() {
    if (window.location.hash) {
      const hash = window.location.hash
      let accordionItem = document.querySelector(hash)

      if (!accordionItem) return false

      if (accordionItem.classList.contains("accordion-item")) {
        openAccordionItem(accordionItem)
      } else {
        accordionItem = accordionItem.closest(".accordion-item")
        if (accordionItem) {
          openAccordionItem(accordionItem)
        }
      }
    }
  }

  accordionGTMEvent(button) {
    const h3 = button.querySelector("h3")
    // Get the value of the data-gtm-label attribute
    const gtmLabel = h3.dataset.gtmLabel
    if (window.dataLayer) {
      window.dataLayer.push({
        event: "accordion_open",
        accordion_title: gtmLabel,
      })
    }
  }

  toggleItem(ev) {
    let button = null

    if (ev.target.localName !== "button") {
      button = ev.target.closest(".accordion-item__button")
    } else {
      button = ev.target
    }

    if (button) {
      const content = document.getElementById(button.getAttribute("aria-controls"))

      if (content.getAttribute("aria-hidden") === "true") {
        content.setAttribute("aria-hidden", "false")
        button.setAttribute("aria-expanded", "true")
        button.classList.toggle("close")
        button.parentElement.classList.toggle("close")

        // GTM accordion open event.
        this.accordionGTMEvent(button)
      } else {
        content.setAttribute("aria-hidden", "true")
        button.setAttribute("aria-expanded", "false")
        button.classList.toggle("close")
        button.parentElement.classList.toggle("close")
      }
    }
  }
}

export default function init() {
  if (document.querySelector(".accordion")) {
    new Accordion()
  }
}
